"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconArrowRight = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("b2b-components/core/components/Icon/Icon/SvgWrapper");
const IconArrowRight = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, props, /*#__PURE__*/_react.default.createElement("path", {
  d: "m12.546 11.975-4.65-4.65L9.4 5.821l6.154 6.154L9.4 18.129l-1.504-1.504 4.65-4.65Z"
}));
exports.IconArrowRight = IconArrowRight;
//# sourceMappingURL=IconArrowRight.js.map